const urlExpandValidity = `${process.env.REACT_APP_MICRO_GLOBAL_ENTITY}extend_property`

export const postExpandValidity = async (data: any, token: string) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': '*',
            'Authorization': `Bearer ${token}`,
            'x-api-key': process.env.REACT_APP_MICRO_GLOBAL_ENTITY_XAPIKEY
        },
        body: JSON.stringify(data),
    };
    const urlRequest = `${urlExpandValidity}`;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
};